import { render, staticRenderFns } from "./competency.vue?vue&type=template&id=5bd3f359&scoped=true"
import script from "./competency.ts?vue&type=script&lang=ts&external"
export * from "./competency.ts?vue&type=script&lang=ts&external"
import style0 from "./competency.scss?vue&type=style&index=0&id=5bd3f359&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3f359",
  null
  
)

export default component.exports